import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import TopBar from '../components/layout/TopBar';
import api from '../utils/api';

const THEMES = [
  ['kindness', '😎 Cool Kindness'], ['jumping', '🐎 Jumping Class'], ['colorful', '🎨 Colorful Words'],
  ['unicorn', '🦄 Unicorn'], ['halloween', '🎃 Halloween'], ['zombie', '🌈 Zombie Unicorn'],
  ['festive', '🎄 Feeling Festive'], ['worryless', '🌈 Worry Less'], ['unicorn2', '🦄 Unicorn II'],
];

const Field = ({ label, k, c, set, placeholder }) => (
  <div className="form-group" style={{ flex: 1, minWidth: 140 }}>
    <label className="form-label">{label}</label>
    <input className="form-input" value={c[k] || ''} placeholder={placeholder || ''} onChange={e => set(k)(e.target.value)} />
  </div>
);
const Row = ({ children }) => <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>{children}</div>;

const StallCardPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [c, setC] = useState(null);
  const [theme, setTheme] = useState('kindness');
  const [downloading, setDownloading] = useState(false);
  const [pickerOpen, setPickerOpen] = useState(false);
  const [picked, setPicked] = useState(false);
  const [showInfo, setShowInfo] = useState(false);

  useEffect(() => {
    (async () => {
      let horse = {}, feeding = { times: [] }, contacts = [], insDoc = null;
      try { horse = (await api.get(`/horses/${id}`)).data || {}; } catch (e) {}
      try { const r = (await api.get(`/feeding/horse/${id}`)).data; feeding = Array.isArray(r) ? { times: r } : r; } catch (e) {}
      try { contacts = (await api.get(`/contacts/horse/${id}`)).data || []; } catch (e) {}
      try {
        const dr = (await api.get('/documents')).data;
        const docs = Array.isArray(dr) ? dr : (dr.documents || []);
        insDoc = docs.filter(d => d.document_type === 'insurance' && d.horse_id === id)
          .sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0))[0] || null;
      } catch (e) {}
      const times = feeding.times || feeding.feeding_times || [];
      const slotMeal = (slots) => {
        const t = times.find(x => slots.includes(x.slot));
        const items = (t && (t.items || t.FeedingItems)) || [];
        const fmt = it => [it.amount, it.unit, it.name, it.soaked ? '(soaked)' : ''].filter(Boolean).join(' ');
        return {
          hay: items.filter(i => i.type === 'hay').map(fmt).join(', '),
          grain: items.filter(i => i.type !== 'hay').map(fmt).join(', '),
        };
      };
      const pick = (list, type) => {
        const hc = list.find(x => ((x.contact && x.contact.type) || x.type) === type);
        const cc = (hc && (hc.contact || hc)) || null;
        return cc ? { name: cc.name || '', phone: cc.phone || '' } : { name: '', phone: '' };
      };
      const trainer = pick(contacts, 'trainer');
      const sexLabel = { mare: 'Mare', filly: 'Mare', gelding: 'Gelding', colt: 'Stallion', stallion: 'Stallion' }[horse.gender] || '';
      setC({
        damSire: horse.dam_sire || '', name: horse.name || '', sire: horse.sire || '', dam: horse.dam || '',
        dob: horse.date_of_birth || '', color: horse.color || '', sex: sexLabel,
        human: '', humanPhone: '',
        trainer: trainer.name, trainerPhone: trainer.phone,
        bHay: slotMeal(['morning']).hay, bGrain: slotMeal(['morning']).grain,
        lHay: slotMeal(['midday']).hay, lGrain: slotMeal(['midday']).grain,
        dHay: slotMeal(['evening']).hay, dGrain: slotMeal(['evening']).grain,
        blanket: horse.blanket_size || '', blanketColor: horse.blanket_color || '',
        sheet: horse.sheet_size || '', sheetColor: horse.sheet_color || '', otherWear: '',
        vetContact: 'yes',
        vetName: horse.vet_name || pick(contacts, 'vet').name,
        vetPhone: horse.vet_phone || pick(contacts, 'vet').phone,
        insurance: (insDoc && insDoc.issued_by) || '', insurancePhone: (insDoc && insDoc.provider_phone) || '',
        other: horse.feed_notes || '',
      });
    })();
  }, [id]);

  const downloadThemed = async () => {
    setDownloading(true);
    try { await api.put('/horses/' + id, { dam_sire: c.damSire || '' }); } catch (e) {}
    try {
      const values = {
        horse_name: c.name, sire: c.sire, dam: c.dam, dob: c.dob, color: c.color, sex: c.sex,
        human: c.human, human_phone: c.humanPhone, trainer: c.trainer, trainer_phone: c.trainerPhone,
        b_hay: c.bHay, b_grain: c.bGrain, l_hay: c.lHay, l_grain: c.lGrain, d_hay: c.dHay, d_grain: c.dGrain,
        blanket_size: c.blanket, blanket_color: c.blanketColor, sheet_size: c.sheet, sheet_color: c.sheetColor,
        wear_other: c.otherWear, vet_contact: c.vetContact, vet_name: c.vetName, vet_phone: c.vetPhone,
        insurance: c.insurance, insurance_phone: c.insurancePhone, other_instructions: c.other,
      };
      const res = await api.post('/stall-cards/generate', { theme, values }, { responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url; a.download = 'stall-card-' + (c.name || 'horse') + '.pdf';
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch (e) { alert('Could not generate the themed card'); }
    finally { setDownloading(false); }
  };

  if (!c) return <div className="loading-screen"><div className="spinner" /></div>;
  const set = k => v => setC(p => ({ ...p, [k]: v }));
  const themeLabel = (THEMES.find(x => x[0] === theme) || [])[1] || 'Design';

  return (
    <div>
      <TopBar title="Stall card" subtitle={c.name || 'Horse'} />
      <div className="page-content">
        {!picked && <div className="cr-make-chooser">
          <div style={{ fontFamily: 'var(--font-display, inherit)', fontSize: 19, marginBottom: 3 }}>
            What do you want to make?
          </div>
          <div style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginBottom: 14 }}>
            You can make more than one. Nothing is published until you say so.
          </div>

          {[
            { key: 'stall',
              name: 'Stall card',
              blurb: 'Hangs on the stall door. Feed, blanket sizes, your contact and the vet. Nine designs to pick from.',
              tag: 'no listing needed',
              colour: '#3E6B4E',
              onPick: () => setPicked(true) },
            { key: 'sales',
              name: 'Sales card',
              blurb: 'For a horse you are selling. Prints with a QR code that opens a public page with photos, pedigree, video and your number.',
              tag: 'creates a public listing',
              colour: '#1A1A1C',
              onPick: () => navigate(`/horses/${id}/sales-card`) },
            { key: 'stud',
              name: 'Stud fee card',
              blurb: 'For a stallion standing at stud. Fee and live foal guarantee on the card, breeding terms on the public page.',
              tag: 'creates a public listing',
              colour: '#2B1020',
              onPick: () => navigate(`/horses/${id}/stud-card`) },
          ].map(opt => {
            const selected = opt.key === 'stall' && picked;
            return (
              <button key={opt.key} type="button"
                onClick={() => { if (opt.onPick) opt.onPick(); }}
                style={{ display: 'flex', gap: 13, alignItems: 'flex-start', width: '100%',
                         textAlign: 'left', background: '#fff', cursor: 'pointer',
                         border: '1px solid ' + (selected ? 'var(--cr-primary)' : 'var(--border-color, #E4DCCE)'),
                         boxShadow: selected ? '0 0 0 2px rgba(52,9,37,.12)' : 'none',
                         borderRadius: 11, padding: 13, marginBottom: 9 }}>
                <span style={{ width: 74, height: 56, borderRadius: 5, flexShrink: 0,
                               background: opt.colour, color: '#fff', fontSize: 9,
                               display: 'flex', alignItems: 'center', justifyContent: 'center',
                               textAlign: 'center', lineHeight: 1.25 }}>
                  {opt.name.toUpperCase()}
                </span>
                <span>
                  <span style={{ fontSize: 14, fontWeight: 600, display: 'block' }}>
                    {opt.name}
                  </span>
                  <span style={{ fontSize: 11.5, color: 'var(--text-secondary)', display: 'block',
                                 marginTop: 3, lineHeight: 1.45 }}>{opt.blurb}</span>
                  <span style={{ display: 'inline-block', fontSize: 9.5, marginTop: 6,
                                 background: 'var(--bg-tertiary, #F3EEE6)', borderRadius: 9,
                                 padding: '2px 8px', color: 'var(--text-secondary)' }}>{opt.tag}</span>
                </span>
              </button>
            );
          })}

        </div>}

        {picked && (
        <div className="cr-picked">
          <button type="button" onClick={() => setPicked(false)}
            style={{ background: 'none', border: 0, padding: 0, marginBottom: 10, cursor: 'pointer',
                     fontSize: 13, color: 'var(--text-secondary)' }}>
            &larr; All card types
          </button>
          <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
            <button className="btn btn-secondary" style={{ flex: 1 }} onClick={() => setPickerOpen(true)}>{themeLabel} &#9662;</button>
            <button onClick={() => setShowInfo(v => !v)} title="Where does this info come from?"
              style={{ background: 'none', border: '1px solid var(--border-color)', borderRadius: 8,
                       cursor: 'pointer', fontSize: 14, color: 'var(--text-muted)', padding: '0 10px' }}>&#9432;</button>
          </div>
        {showInfo && (
          <div className="card" style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 8 }}>
            Details are pulled automatically from {c.name || 'this horse'}'s profile (name, DOB, sire &amp; dam, color, sex, blanketing, vet), feeding schedule (meals), and contacts (trainer). Edits here only change the printed card — never the horse's records.
          </div>
        )}

        <div className="section-label">Horse</div>
        <div className="card">
          <Row><Field label="Name" k="name" c={c} set={set} /></Row>
          <Row><Field label="Sire" k="sire" c={c} set={set} /><Field label="Dam" k="dam" c={c} set={set} /></Row>
          <Row><Field label="Dam's sire" k="damSire" c={c} set={set} placeholder="prints on the sales card" /></Row>
          <Row>
            <Field label="Date of birth" k="dob" c={c} set={set} />
            <Field label="Color" k="color" c={c} set={set} />
            <div className="form-group" style={{ flex: 1, minWidth: 140 }}>
              <label className="form-label">Sex</label>
              <select className="form-input" value={c.sex} onChange={e => set('sex')(e.target.value)}>
                <option value="">—</option><option>Gelding</option><option>Mare</option><option>Stallion</option>
              </select>
            </div>
          </Row>
        </div>

        <div className="section-label">People</div>
        <div className="card">
          <Row><Field label="My human" k="human" c={c} set={set} /><Field label="Phone" k="humanPhone" c={c} set={set} /></Row>
          <Row><Field label="My trainer" k="trainer" c={c} set={set} /><Field label="Phone" k="trainerPhone" c={c} set={set} /></Row>
        </div>

        <div className="section-label">Meals</div>
        <div className="card">
          <Row><Field label="Breakfast hay" k="bHay" c={c} set={set} /><Field label="Breakfast grain" k="bGrain" c={c} set={set} /></Row>
          <Row><Field label="Lunch hay" k="lHay" c={c} set={set} /><Field label="Lunch grain" k="lGrain" c={c} set={set} /></Row>
          <Row><Field label="Dinner hay" k="dHay" c={c} set={set} /><Field label="Dinner grain" k="dGrain" c={c} set={set} /></Row>
        </div>

        <div className="section-label">Blanketing</div>
        <div className="card">
          <Row><Field label="Blanket size" k="blanket" c={c} set={set} placeholder="e.g. 78" /><Field label="Blanket color" k="blanketColor" c={c} set={set} /></Row>
          <Row><Field label="Sheet size" k="sheet" c={c} set={set} /><Field label="Sheet color" k="sheetColor" c={c} set={set} /></Row>
          <Row><Field label="Other wear" k="otherWear" c={c} set={set} placeholder="e.g. Fly mask in turnout" /></Row>
        </div>

        <div className="section-label">Emergency</div>
        <div className="card">
          <div className="form-group">
            <label className="form-label">If there's an emergency…</label>
            <select className="form-input" value={c.vetContact} onChange={e => set('vetContact')(e.target.value)}>
              <option value="yes">Contact my veterinarian immediately</option>
              <option value="no">Contact me before the veterinarian</option>
            </select>
          </div>
          <Row><Field label="Veterinarian" k="vetName" c={c} set={set} /><Field label="Phone" k="vetPhone" c={c} set={set} /></Row>
          <Row><Field label="Insurance company" k="insurance" c={c} set={set} /><Field label="Phone" k="insurancePhone" c={c} set={set} /></Row>
        </div>

        <div className="section-label">Other instructions</div>
        <div className="card" style={{ marginBottom: 14 }}>
          <textarea className="form-input" rows={3} value={c.other} onChange={e => set('other')(e.target.value)} placeholder="Anything the barn should know" />
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 22 }}>
          <button className="btn btn-primary" onClick={downloadThemed} disabled={downloading}>
            {downloading ? 'Making\u2026' : '\u2b07\ufe0f Download stall card'}
          </button>
        </div>
        </div>
        )}
      </div>

      {pickerOpen && (
        <div onClick={() => setPickerOpen(false)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', zIndex: 60, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
          <div onClick={e => e.stopPropagation()} style={{ background: 'var(--bg-primary)', borderRadius: '16px 16px 0 0', width: '100%', maxWidth: 640, maxHeight: '75vh', overflowY: 'auto', padding: '14px 14px 20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
              <strong style={{ flex: 1, fontSize: 15 }}>Choose a design</strong>
              <button onClick={() => setPickerOpen(false)} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: 'var(--text-muted)' }}>×</button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 10 }}>
              {THEMES.map(([tid, label]) => (
                <button key={tid} onClick={() => { setTheme(tid); setPickerOpen(false); }}
                  style={{ border: theme === tid ? '2px solid var(--cr-primary)' : '1px solid var(--border-color)', borderRadius: 10, padding: 6, background: 'var(--bg-secondary)', cursor: 'pointer', textAlign: 'center' }}>
                  <img src={'/stallcard-previews/' + tid + '.jpg'} alt="" style={{ width: '100%', borderRadius: 6, display: 'block' }}
                    onError={e => { e.target.style.display = 'none'; }} />
                  <div style={{ fontSize: 12, fontWeight: 600, marginTop: 6 }}>{label}</div>
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StallCardPage;
